import './q-r-care-center-inside.scss'
// libraries
import { QrReader } from 'react-qr-reader'
// hooks
import useUIActions from 'hooks/useUIActions'
import useQRCareCenter from 'modules/CareNetwork/hooks/useQRCareCenter'
import useClasses from 'modules/Classes/hooks/useClasses'
import useCurrentLesson from 'hooks/useCurrentLesson'
// utils
import sendGaPush from 'utils/sendGaPush'
// components
import Button from 'components/atoms/button/button'
import Image from 'components/atoms/Image/image'
import Loading from 'components/atoms/loading/loading'
import Card from 'components/atoms/card/card'
// icons
import { CloseIcon, IconsSVG } from 'components/atoms/icons'
// image
import backImage from 'assets/images/q-r/pantalla_qr.svg'
import calendarImg from 'assets/images/q-r/calendar.png'
// types
import QRCareCenterInsideTypes from './q-r-care-center-inside-types'

const planStatusTypes = {
	active: 'Activo',
	consumed: 'Consumido',
	unActive: 'Inactivo'
}
const validTicketPlan = '12 entradas'

const QRCareCenterInside = props => {
	const {
		type,
		element,
		content: { loading: ContentLoading, noHaveCareCenterPlan, noTicketsRemaining, unActive } = {}
	} = props

	// hooks
	const { hideOverlay } = useUIActions()
	const {
		loadingClasses,
		isSubscriptionData: {
			planStatus,
			haveCareCenterPlan,
			ticketsRemainning: ticketsRemaining,
			planType,
			secondTimeInLessThanThreeHours
		} = false,
		setDate,
		frequencyHour
	} = useClasses()
	const { lessonState } = useCurrentLesson()
	const { QRloading, QRSuccess, getQRData, constraints, goActivatePlan } = useQRCareCenter({
		type,
		secondTimeInLessThanThreeHours,
		lessonId: element ? element?.id : lessonState?.id
	})

	// data
	const listDataToShow = {
		noHaveCareCenterPlan: [
			{
				onClick: () => goActivatePlan(),
				classes: ''
			},
			{
				onClick: () => hideOverlay(),
				classes: 'pink mt2'
			}
		],
		noTicketsRemaining: [
			{
				onClick: () => goActivatePlan(),
				classes: ''
			},
			{
				onClick: () => hideOverlay(),
				classes: 'pink mt2'
			}
		],
		unActive: [
			{
				title: 'QUIERO COMPRAR OTRO PLAN',
				onClick: () => goActivatePlan(),
				classes: ''
			},
			{
				title: 'VOLVER',
				onClick: () => hideOverlay(),
				classes: 'pink mt2'
			}
		],
		noPermission: [
			{
				title: 'ACEPTO EL USO DE LA CÁMARA',
				onClick: () => null,
				classes: ''
			},
			{
				title: 'VOLVER',
				onClick: () => hideOverlay(),
				classes: 'pink mt2'
			}
		]
	}
	const cardLessonData = type === QRCareCenterInsideTypes.class && (element || lessonState)

	// metrics
	const handleSendGaPush = ({ action = 'ClicQRCentrosDelCuidado', label }) => {
		sendGaPush({ category: 'SaludContinuarediseno', action, label })
	}

	// render
	const renderElement = ({ data, buttonsData }) => {
		const { img, title, text, buttons = [] } = data

		return (
			<section className='m-q-r-care-center-inside no_care_center_plan container'>
				{img && (
					<Image src={img} alt={title} width='120' height='105' classes='mb3 mr ml' fit='contain' />
				)}
				{title && <h3 className='mb1'>{title}</h3>}
				{text && <p className='mb3'>{text}</p>}
				{buttons.map((button, index) => {
					const { title: buttonTitle } = button
					const { onClick, classes } = buttonsData[index]
					return (
						<Button
							key={buttonTitle}
							uppercase
							title={buttonTitle}
							onClick={() => {
								handleSendGaPush({ label: `${title} - ${buttonTitle}` })
								onClick()
							}}
							classes={classes}
						/>
					)
				})}
			</section>
		)
	}

	if (loadingClasses || ContentLoading) return <Loading small={true} />

	if (!haveCareCenterPlan || planStatus === planStatusTypes.consumed) {
		return renderElement({
			data: noHaveCareCenterPlan,
			buttonsData: listDataToShow.noHaveCareCenterPlan
		})
	}

	if (planType === validTicketPlan && !ticketsRemaining) {
		return renderElement({
			data: noTicketsRemaining,
			buttonsData: listDataToShow.noTicketsRemaining
		})
	}

	if (planStatus === planStatusTypes.unActive) {
		return renderElement({ data: unActive, buttonsData: listDataToShow.unActive })
	}

	if (QRSuccess) {
		const {
			numberOfTickets,
			planType,
			numberOfTicketsRemainning: numberOfTicketsRemaining,
			firstTime,
			initialDate,
			terminationDate
		} = QRSuccess
		const isClass = type === QRCareCenterInsideTypes.class

		const setTitle = () => {
			if (isClass) return <h3 className='mb1'>¡Asistencia confirmada!</h3>
			if (firstTime) return <h3 className='mb1'>Hoy inicias tu plan de {planType}</h3>
			return <h3 className='mb1'>¡Gracias por registrar tu ingreso!</h3>
		}

		const setTextBold = () => {
			if (isClass) return <p className='bold mb1'>Disfruta tu clase de {cardLessonData.title}</p>
			return (
				<p className='bold mb1'>
					Tu plan actual es: <span className='pink'>{planType}</span>
				</p>
			)
		}

		const setText = () => {
			if (isClass) {
				return (
					<p className='big mb1'>
						Te quedan{' '}
						<strong>
							{numberOfTickets} de {numberOfTicketsRemaining}
						</strong>{' '}
						clases para asistir este mes con tu plan premium
					</p>
				)
			}

			if (planType.includes('entradas')) {
				return (
					<p className='big mb1'>
						Te quedan{' '}
						<strong>
							{numberOfTickets} entradas de {numberOfTicketsRemaining}
						</strong>{' '}
						a nuestros Centros de Cuidado
					</p>
				)
			}

			return (
				<p className='small'>
					<strong>Fecha de inicio:</strong>
					{initialDate}
					<br />
					<strong>Fecha de finalización:</strong>
					{terminationDate}
				</p>
			)
		}

		return (
			<section className='m-q-r-care-center-inside no_care_center_plan container pt6'>
				<Image
					src={calendarImg}
					alt={setTitle()}
					width='105'
					height='105'
					classes='mb3 mr ml'
					fit='contain'
				/>
				<div className={isClass ? '' : 'align_left'}>
					{setTitle()}
					{setTextBold()}
					{setText()}
				</div>
				<Button
					uppercase
					title='ENTENDIDO'
					classes='pink mt3'
					onClick={() => {
						handleSendGaPush({ label: `${setTitle()} - ENTENDIDO` })
						hideOverlay()
					}}
				/>
			</section>
		)
	}

	return (
		<section className='m-q-r-care-center-inside'>
			<header className='container'>
				<button className='m-q-r-care-center-inside__header-close' onClick={() => hideOverlay()}>
					<CloseIcon color='#EE2B7B' />
				</button>
				{type === QRCareCenterInsideTypes.careCenter ? (
					<p>Escanea el QR en la entrada del Centro de Cuidado para registrar tu ingreso</p>
				) : (
					<p>Escanea el QR en la sala de clase</p>
				)}
			</header>

			<section className='m-q-r-care-center-inside__qr'>
				{QRloading ? (
					<Loading small={true} />
				) : (
					<>
						<QrReader
							onResult={(result, error) => getQRData(result, error)}
							className='m-q-r-care-center-inside__qr__camera'
							constraints={constraints}
							scanDelay={1000}
							styles={{ height: '100%', width: '100%' }}
						/>

						<img src={backImage} alt='' className='m-q-r-care-center-inside__qr__img' />
					</>
				)}

				{cardLessonData && (
					<Card classes='m-q-r-care-center-inside__qr__card'>
						<section>
							{cardLessonData.title && <p className='title'>{cardLessonData.title}</p>}{' '}
							{cardLessonData.initialHour && <p>{setDate(cardLessonData.initialHour)}</p>}{' '}
						</section>
						<section>
							{cardLessonData.initialHour && (
								<span>
									<IconsSVG icon='clock' color='#EE2B7B' />
									{frequencyHour({
										init: cardLessonData.initialHour,
										end: cardLessonData.finalHour
									})}
								</span>
							)}
						</section>
						<section>
							<p>
								<strong>Lugar:</strong>
								{` ${cardLessonData.location}, ${cardLessonData.place}`}
							</p>
						</section>
					</Card>
				)}
			</section>
		</section>
	)
}

export default QRCareCenterInside
